import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import { Employee } from './EmployeeSelector';
import PreferredEmployees from './PreferredEmployees';
import { PreferredEmployee, CreatedBy } from './PreferredEmployees.types';
import { PreferredEmployeeCreatedBy } from './PreferredEmployees.enums';
import { StyledDialogMedium } from './Dialog/Dialog.styles';
import { AxiosResponse } from 'axios';

type Props = {
  open: boolean;
  date: Date;
  employees: PreferredEmployee[];
  createdBy: CreatedBy;
  dialogContainer: HTMLElement;
  showProposed?: boolean;
  addEmployee?: (
    employee: Employee
  ) => Promise<AxiosResponse<any, any> | undefined>;
  removeEmployee?: (
    employee: Employee
  ) => Promise<AxiosResponse<any, any> | undefined>;
  onHidden: () => void;
  setSelectedEmployees: Dispatch<SetStateAction<PreferredEmployee[]>>;
};

export default function PreferredEmployeesDialog(props: Props) {
  const {
    open = true,
    date,
    employees,
    createdBy,
    dialogContainer,
    showProposed,
    addEmployee,
    removeEmployee,
    onHidden,
    setSelectedEmployees
  } = props;
  const { t } = useTranslation('common');
  const [hide, setHide] = useState(false);

  const handleClose = () => {
    onHidden?.() ?? setHide(false);
  };

  return (
    <StyledDialogMedium
      title={t(
        showProposed
          ? 'flexMatchDialog.addProposedEmployees'
          : 'preferredEmployees'
      )}
      open={hide ? false : open}
      onHidden={onHidden}
      container={dialogContainer}
    >
      <PreferredEmployees
        date={date}
        employees={employees}
        setSelectedEmployees={setSelectedEmployees}
        createdBy={createdBy}
        onlyFlex={createdBy === PreferredEmployeeCreatedBy.FLEX_PLANNER}
        addEmployee={addEmployee}
        removeEmployee={removeEmployee}
        showProposed={showProposed}
      />
      <DialogActions>
        <Button onClick={handleClose} color="secondary" variant="contained">
          {t('close')}
        </Button>
      </DialogActions>
    </StyledDialogMedium>
  );
}
